<template>
  <v-container fluid class="py-0" grid-list-md>
    <v-row justify="center">
      <v-col cols="12" md="11" mx-auto>
        <v-card flat>
          <v-card-title class="px-0 py-2">
            <v-combobox
            v-model="curComm"
            label="Community"
            :items="commList"
            item-text="comm_name"
            item-value="comm_id"
            placeholder="Choose"
            @input="curComm ? loadRepositoryBasedOnComm(curComm) : ''"
            filled
            clearable
            ></v-combobox>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12 mx-auto>
          <!-- Repository -->
          <v-flex xs12 sm12 v-for="(cat, i) in reposCat" :key = "i">
            <v-card>
              <v-card-title class="py-2 title grey lighten-4">
                {{ cat.repos_cat }}
              </v-card-title>
              <v-card-text class="pa-0" :style="reposit.filter(rec => rec.repos_cat_id === cat.repos_cat_id).length > 5 ? 'overflow-y: scroll; height: 300px; padding: 1rem 1rem 1rem 0px;' : ''">
                <v-data-table
                :headers="cat.repos_cat_id === 1 ? reposHeaderAgreement : reposHeader"
                :items="reposit.filter(rec => rec.repos_cat_id === cat.repos_cat_id)"
                hide-default-footer
                disable-pagination
                >
                  <template slot="item" slot-scope="props">
                    <!-- Show the items for category Contract & Agreements (cat_id != 1) -->
                    <tr v-if="cat.repos_cat_id === 1" @click="prepareUpdateReposit(props.item)">
                      <td style="text-align:left; font-size: 12px">{{ props.item.doc_name ? props.item.doc_name : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">
                        <a :href="props.item.doc_url" download style="text-decoration: none;">
                          <v-btn small icon onclick="event.stopPropagation()" class="mr-0 grey lighten-1 grey--text text--lighten-4">
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </a>
                      </td>
                      <td style="text-align:center; font-size: 12px">{{ props.item.upload_dt ? handy.formatDate(props.item.upload_dt) : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">{{ props.item.vendor_name ? props.item.vendor_name : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">{{ props.item.scope_of_work ? props.item.scope_of_work : '-' }}</td>
                      <td style="text-align:center; font-size: 12px">{{ props.item.contract_start_dt ? handy.formatDate(props.item.contract_start_dt) : '-' }}</td>
                      <td style="text-align:center; font-size: 12px">{{ props.item.contract_end_dt ? handy.formatDate(props.item.contract_end_dt) : '-' }}</td>
                      <td style="text-align:right; font-size: 12px">{{ props.item.contract_value ? handy.formatCur(props.item.contract_value) : '-' }}</td>
                      <td style="text-align:center; font-size: 12px">{{ props.item.payment_frequency ? props.item.payment_frequency : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">{{ props.item.contact_phone ? props.item.contact_phone : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">{{ props.item.contact_email ? props.item.contact_email : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">{{ props.item.remarks ? props.item.remarks : '-' }}</td>
                    </tr>
                    <!-- Show the items category other than Contract & Agreements (cat_id != 1) -->
                    <tr v-if="cat.repos_cat_id != 1" @click="prepareUpdateReposit(props.item)">
                      <td style="text-align:left; font-size: 12px">{{ props.item.doc_name ? props.item.doc_name : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">
                        <a :href="props.item.doc_url" download style="text-decoration: none;">
                          <v-btn small icon onclick="event.stopPropagation()" class="mr-0 grey lighten-1 grey--text text--lighten-4">
                            <v-icon small>mdi-download</v-icon>
                          </v-btn>
                        </a>
                      </td>
                      <td style="text-align:center; font-size: 12px">{{ props.item.upload_dt ? handy.formatDate(props.item.upload_dt) : '-' }}</td>
                      <td style="text-align:left; font-size: 12px">{{ props.item.remarks ? props.item.remarks : '-' }}</td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" v-if="config.IS_EDITED_BY_USER"
            :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
            dark fab fixed
            color="accent black--text"
            @click.native="prepareRepository(curComm)">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span class="caption">Add Repository</span>
        </v-tooltip>
      </v-layout>
    </v-flex>

    <!-- Insert, Update and Delete Repository -->
    <v-dialog v-model="showRepositEdit" persistent max-width="600px">
      <v-container grid-list-md class="pa-0" fluid full-height>
        <v-flex xs12>
          <v-form ref="lForm" @submit.prevent="saveChanges(lAction)">
            <v-card scrollable>
              <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                {{ handy.startWithUpper(lAction) }} Repository
                <v-spacer></v-spacer>
                <v-btn icon small @click.stop="showRepositEdit = false"><v-icon>mdi-close</v-icon></v-btn>
              </v-card-title>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-autocomplete
                    v-model="lReposit.repos_cat_id"
                    :items="reposCat"
                    label="Repository Category"
                    item-text="repos_cat"
                    item-value="repos_cat_id"
                    hide-details
                    style="font-size: 14px"
                    :rules="[rules.required]"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs8 v-if="lReposit.repos_cat_id === 1">
                    <v-autocomplete
                    v-model="lReposit.rep_vendor_id"
                    :items="vendorList"
                    label="Vendor Name"
                    item-text="vendor_name"
                    item-value="vendor_id"
                    hide-details
                    clearable
                    style="font-size: 14px"
                    @input="loadSelectedVendorDetails()"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 v-if="lReposit.repos_cat_id === 1">
                    <v-text-field
                    v-model="lReposit.contact_name"
                    label="Vendor Contact Name"
                    hide-details
                    disabled
                    style="font-size: 14px"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-if="lReposit.repos_cat_id === 1">
                    <v-text-field
                    v-model="lReposit.contact_phone"
                    label="Vendor Contact Number"
                    hide-details
                    disabled
                    style="font-size: 14px"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 v-if="lReposit.repos_cat_id === 1">
                    <v-text-field
                    v-model="lReposit.contact_email"
                    label="Vendor Contact email"
                    hide-details
                    disabled
                    style="font-size: 14px"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 v-if="lReposit.repos_cat_id === 1">
                    <v-text-field
                    v-model="lReposit.contract_value"
                    label="Contract Value"
                    hide-details
                    type="Number"
                    maxlength="10"
                    style="font-size: 14px"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 v-if="lReposit.repos_cat_id === 1">
                    <v-dialog ref="contractStartDt"
                    persistent v-model="contractStartDt"
                    max-width="290px"
                    :return-value.sync="lReposit.contract_start_dt"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="Contract Start Date"
                        v-model="lReposit.contract_start_dt"
                        append-icon="mdi-calendar-today"
                        readonly clearable
                        hide-details
                        style="font-size: 14px"
                        v-on="on"
                        required
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="lReposit.contract_start_dt" scrollable
                      first-day-of-week="1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text @click="contractStartDt = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.contractStartDt.save(lReposit.contract_start_dt)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs4 v-if="lReposit.repos_cat_id === 1">
                    <v-dialog ref="contractEndDt"
                    persistent v-model="contractEndDt"
                    max-width="290px"
                    :return-value.sync="lReposit.contract_end_dt"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                        slot="activator" label="Contract End Date"
                        v-model="lReposit.contract_end_dt"
                        append-icon="mdi-calendar-today"
                        readonly clearable
                        hide-details
                        style="font-size: 14px"
                        v-on="on"
                        required
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="lReposit.contract_end_dt" scrollable
                      first-day-of-week="1"
                      >
                        <v-spacer></v-spacer>
                        <v-btn text @click="contractEndDt = false">Cancel</v-btn>
                        <v-btn text color="accent" @click="$refs.contractEndDt.save(lReposit.contract_end_dt)">OK</v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-flex>
                  <v-flex xs4 v-if="lReposit.repos_cat_id === 1">
                    <v-autocomplete
                    v-model="lReposit.payment_frequency"
                    :items="frequency_list"
                    label="Payment Frequency"
                    hide-details
                    style="font-size: 14px"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs8 v-if="lReposit.repos_cat_id === 1">
                    <v-text-field
                    v-model="lReposit.scope_of_work"
                    label="Scope of Work"
                    hide-details
                    maxlength="250"
                    style="font-size: 14px"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-textarea
                    v-model="lReposit.remarks"
                    label="Remarks (if any)"
                    rows="2"
                    hide-details
                    maxlength="250"
                    style="font-size: 14px"
                    ></v-textarea>
                  </v-flex>
                  <v-flex xs12 v-if="lAction === 'create'">
                    <input style="display:none" type="file" ref="fileInput"
                    accept=".xls, .xlsx, .eml, .csv, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lReposit)"/>
                    <v-btn icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
                    <span v-if="lReposit.files && lReposit.files.filter(rec => rec.is_selected).length > 0">
                      <span v-for="(file, index) in lReposit.files.filter(rec => rec.is_selected)" :key="index">
                        <span v-if="file.is_selected">
                          <v-chip small close class = "mb-2" @click:close="removeSelectedFile(file)">{{ file.doc_name }}</v-chip>
                        </span>
                      </span>
                    </span>
                    <span v-else class="caption">Attachment if any (upto 20MB)</span>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <input style="display:none" type="file" ref="fileInput"
                    accept=".xls, .xlsx, .eml, .csv, .pdf, .ppt, .pptx, .doc, .docx, image/png, image/gif, image/jpeg" @change="loadFilesFromFileBrowser(lReposit)"/>
                    <v-btn v-if="lReposit.files && lReposit.files.filter(rec => rec.is_selected).length === 0" icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
                    <span v-if="lReposit.files && lReposit.files.filter(rec => rec.is_selected).length > 0">
                      <span v-for="(file, index) in lReposit.files.filter(rec => rec.is_selected)" :key="index">
                        <span v-if="file.is_selected">
                          <v-chip small close class = "mb-2" @click:close="removeSelectedFile(file)">{{ file.doc_name }}</v-chip>
                        </span>
                      </span>
                    </span>
                    <span v-else class="caption">Attachment if any (upto 20MB)</span>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions class="pt-0">
                <v-layout row wrap>
                  <v-spacer></v-spacer>
                  <v-btn @click.stop="cancelChanges">Cancel</v-btn>
                  <v-btn v-if="lAction === 'update' && config.IS_EDITED_BY_USER" @click="deleteReposit(lReposit)">delete</v-btn>
                  <v-btn v-if="config.IS_EDITED_BY_USER" type="submit" color="accent black--text" :disabled="beingSaved">Save</v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-flex>
      </v-container>
    </v-dialog>

    <!-- snack bar for reporting -->
    <v-snackbar :color="sbarCol" v-model="sbar" :timeout="2500" multi-line>
      <span class="mx-auto">{{ sbarMsg }}</span>
    </v-snackbar>

  </v-container>
</template>


<script>
import handy from '@/utils/handy'
import config from '@/config/app-cfg'

export default {
  data () {
    return {
      // Common Declarations
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      curComm: '',
      commList: [],
      vendorList: [],
      lAction: '',
      // Repository Load Declarations
      reposCat: [],
      reposit: [],
      lRepository: [],
      lCommName: '',
      lCommId: null,
      frequency_list: ['One-Time', 'Monthly', 'Quarterly', 'Half-Yearly', 'Yearly', 'Not Applicable'],
      reposHeader: [
        { text: 'Document Name', value: 'doc_name', width: '320px' },
        { text: 'Download', value: '', width: '120px' },
        { text: 'Upload Date', value: 'upload_dt', align: 'center', width: '120px' },
        { text: 'Remarks', value: 'remarks', width: '800px' }
      ],
      reposHeaderAgreement: [
        { text: 'Document Name', value: 'doc_name', align: 'left', width: '320px', sortable: false },
        { text: 'Download', value: '', width: '120px', align: 'left', sortable: false },
        { text: 'Upload Date', value: 'upload_dt', align: 'center', width: '120px' },
        { text: 'Vendor Name', value: 'vendor_name', width: '250px', sortable: false  },
        { text: 'Scope Of Work', value: 'scope_of_work', width: '150px', sortable: false  },
        { text: 'Contract Start Date', value: 'contract_start_dt', align: 'center', width: '150px', sortable: false },
        { text: 'Contract End Date', value: 'contract_end_dt', align: 'center', width: '150px', sortable: false  },
        { text: 'Contract Value', value: 'contract_value', align: 'right', width: '120px', sortable: false  },
        { text: 'Payment Frequency', value: 'payment_frequency', align: 'center', width: '150px', sortable: false  },
        { text: 'Contact Number', value: 'contact_phone', width: '150px', sortable: false  },
        { text: 'eMail Ids', value: 'contact_email', width: '150px', sortable: false  },
        { text: 'Remarks', value: 'remarks', width: '300px', sortable: false  }
      ],
      lReposit: [],
      showRepositEdit: false,
      contractStartDt: false,
      contractEndDt: false,

    }
  },
  mounted () {
    this.loadCommunityName()
    this.lAction = 'view'
  },
  methods: {
    // Common Methods
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadCommunityName () {
      var qry = {
        params: {
          vendor_id : config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    loadRepositoryBasedOnComm (curComm) {
      this.loadReposCat()
      this.loadRepository(curComm.comm_id)
      this.loadVendorDetails(curComm.comm_id)
      this.lRepository = Object.assign({}, curComm)
      this.lCommName = curComm.comm_name
      this.lCommId = curComm.comm_id
    },
    loadReposCat () {
      this.axios.get(config.SMARTILITY_API_URL + '/getRepositoryCategory/')
      .then(response => {
        this.reposCat = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadRepository (comm_id) {
      var qry = {
        params: {
          comm_id: comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getRepositoryByCommId/', qry)
      .then(response => {
        this.reposit = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    prepareUpdateReposit (curRepos) {
      this.lReposit = Object.assign({}, curRepos)
      this.lReposit.old_repos_cat_id = curRepos.repos_cat_id
      this.lReposit.contract_start_dt = curRepos.contract_start_dt ? handy.formatDBDate(curRepos.contract_start_dt) : ''
      this.lReposit.contract_end_dt = curRepos.contract_start_dt ? handy.formatDBDate(curRepos.contract_end_dt) : ''
      this.loadRepositAttachment(this.lReposit)
      this.loadVendorDetails(this.lReposit.comm_id)
      this.lAction = 'update'
      this.showRepositEdit = true
    },
    prepareRepository (curComm) {
      this.lReposit = {
        comm_id: curComm.comm_id,
        repos_cat_id: null,
        remarks: '',
        files: [],
        rep_vendor_id: null,
        scope_of_work: null,
        contract_start_dt: null,
        contract_end_dt: null,
        contract_value: null,
        payment_frequency: null
      }
      this.loadVendorDetails(this.lReposit.comm_id)
      this.lAction = 'create'
      this.showRepositEdit = true
    },
    loadRepositAttachment (curReposit) {
      var path = require('path')
      var qry = {
        params: {
          doc_id: curReposit.doc_id
        }
      }
      curReposit.files = []
      this.axios.get(config.SMARTILITY_API_URL + '/getAttachmentByDocId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          curReposit.files.push({
            doc_url: rec.doc_url,
            doc_name: path.basename(rec.doc_url),
            is_selected: true,
            is_changed: false
          })
        })
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, true)
        curReposit.files = []
      })
    },
    cancelChanges () {
      this.lAction = 'view'
      this.showRepositEdit = false
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curReposit) {
      const files = event.target.files
      let currentDate = new Date()
      var seconds = currentDate.getSeconds().toString()
      if(seconds.length < 2) {
        seconds = '0' + seconds
      }
      let time = seconds + currentDate.getMilliseconds().toString()
      if (!curReposit.files) {
        curReposit.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curReposit.files.push({
              doc_url: e.target.result.split(',')[1],
              doc_name: file.name.split('.')[0] + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
    },
    saveChanges (action) {
      if (this.$refs.lForm.validate()) {
        if (this.lReposit.files.length > 0 && this.lReposit.files.filter(rec => rec.is_selected).length > 0) {
          if (this.lReposit.repos_cat_id === 1 && (!this.lReposit.rep_vendor_id || !this.lReposit.contract_start_dt || !this.lReposit.contract_end_dt || !this.lReposit.contract_value || !this.lReposit.payment_frequency )) {
            this.msg('Please enter mandatory vendor related fields', 0)
          } else {
            this.axios.post(config.SMARTILITY_API_URL + '/repository/' + action, this.lReposit)
            .then(response => {
              this.msg('Saved Successfully', 1)
              this.beingSaved = false
              this.lAction = 'view'
              this.showRepositEdit = false
              setTimeout(() => {
                this.loadRepository(this.lReposit.comm_id)
              }, 500)
            })
            .catch(err => {
              this.msg(err, 0)
              this.beingSaved = false
            })
          }
        } else {
          this.msg('Please attach file', 0)
        }
      }
    },
    deleteReposit (curReposit) {
      if (!confirm('Sure, you want to delete the Repository with name ' + curReposit.doc_name)) {
        return
      }
      // up in db
      this.axios.post(config.SMARTILITY_API_URL + '/repository/delete', curReposit)
      .then(response => {
        this.loadReposCat()
        this.loadRepository(this.lCommId)
        this.lAction = 'view'
        this.showRepositEdit = false
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
        this.beingSaved = false
      })
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    loadVendorDetails (comm_id) {
      var qry = {
        params: {
          comm_id: comm_id
        }
      }
      this.axios.get(config.SMARTILITY_API_URL + '/getRepositoryVendorsByCommId/', qry)
      .then(response => {
        this.vendorList = response.data
      })
      .catch(err => {
        this.msg(err, true)
      })
    },
    loadSelectedVendorDetails () {
      if (this.lReposit.rep_vendor_id) {
        var tempItem = this.vendorList.filter( rec => rec.vendor_id === this.lReposit.rep_vendor_id)
        if (tempItem.length > 0) {
          this.lReposit.contact_name = tempItem[0].contact_name
          this.lReposit.contact_phone = tempItem[0].contact_phone
          this.lReposit.contact_email = tempItem[0].contact_email
        }
      } else {
        this.lReposit.contact_name = null
        this.lReposit.contact_phone = null
        this.lReposit.contact_email = null
      }
    },
  }
}

</script>
